import { useMemo } from "react";

import { usePermissions } from "@/features/auth";

import { useGetPowerBiDashboards } from "./useGetPowerBiDashboards";

export const useAllowedPowerBiDashboards = () => {
  const { data: dashboards, ...query } = useGetPowerBiDashboards();
  const isAllowedTo = usePermissions((state) => state.isAllowedTo);

  // Filtra dashboards habilitados/permitidos para el usuario logeado
  const allowed = useMemo(() => {
    return dashboards.filter((dashboard) => {
      return isAllowedTo([dashboard.code]);
    });
  }, [isAllowedTo, dashboards]);

  return { data: allowed, ...query };
};
